import { render, staticRenderFns } from "./ProductCloud.vue?vue&type=template&id=7c8f8566&scoped=true"
import script from "./ProductCloud.vue?vue&type=script&lang=js"
export * from "./ProductCloud.vue?vue&type=script&lang=js"
import style0 from "./ProductCloud.vue?vue&type=style&index=0&id=7c8f8566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f8566",
  null
  
)

export default component.exports